import React from 'react'
import sri_lanka from '../../assets/images/sri-lanka-1.png';

import './about.css'; 


function About() {
    return (
        <div className="background-color">
            <div className="header who-we-are"></div>
            <div id="projects" className="section">
                <div className="container">
                    <h1 className="gm-heading-1">From us, To them</h1>
                    <img src={sri_lanka} sizes="100vw"
                         className="who-we-are-map" />
                    <p>Gammadda, loosely translating to the “heart of the village” was born from the idea of connectivity. Of bridging the political, economical, religious and cultural divide to find those truly in need. After years of broken promises from successive Governments, News 1st began the Gammadda initiative and it has become not just a word, but a symbol of hope of an entire nation. In all of Sri Lanka’s history, this is the largest ongoing humanitarian initiative TODAY.</p>
                </div>
            </div>
            <div id="projects" className="section">
    <div className="container">
      <h2 className="gm-heading-2">Vision</h2>
      <p>Gammadda is built on the foundation of connectivity. We believe in uplifting the forgotten and giving them a chance for a better tomorrow. By engaging multiple stakeholders who are passionate about ensuring rural development of Sri Lanka, we enable the successful planning and implementation of projects from various parts of Sri Lanka.</p>
      <a href="gammadda-universe" className="button how-it-works">Learn more</a>
    </div>
  </div>
        </div>
    )
}

export default About